import { FHA } from '../constants/mapLayerIds';

export const scoutingIntervals = [
  { r: 0, g: 100, b: 0, stringValue: '' },
  { r: 0, g: 203, b: 0, stringValue: '' },
  { r: 190, g: 252, b: 15, stringValue: '' },
  { r: 255, g: 246, b: 13, stringValue: '' },
  { r: 244, g: 0, b: 0, stringValue: '' },
];

export const vegetationV1ScaleColors = [
  { r: 1, g: 84, b: 12, stringValue: '' },
  { r: 0, g: 119, b: 16, stringValue: '' },
  { r: 52, g: 142, b: 0, stringValue: '' },
  { r: 0, g: 181, b: 25, stringValue: '' },
  { r: 98, g: 187, b: 47, stringValue: '' },
  { r: 135, g: 196, b: 0, stringValue: '' },
  { r: 159, g: 226, b: 12, stringValue: '' },
  { r: 204, g: 255, b: 0, stringValue: '' },
  { r: 255, g: 238, b: 41, stringValue: '' },
  { r: 255, g: 247, b: 148, stringValue: '' },
];

export const vegetationV2ScaleColors = [
  { r: 66, g: 70, b: 107, stringValue: '' },
  { r: 2, g: 72, b: 3, stringValue: '' },
  { r: 21, g: 124, b: 8, stringValue: '' },
  { r: 36, g: 162, b: 14, stringValue: '' },
  { r: 52, g: 203, b: 20, stringValue: '' },
  { r: 119, g: 219, b: 14, stringValue: '' },
  { r: 194, g: 233, b: 6, stringValue: '' },
  { r: 252, g: 244, b: 0, stringValue: '' },
  { r: 188, g: 133, b: 46, stringValue: '' },
  { r: 176, g: 177, b: 184, stringValue: '' },
];

export function getFHAIntervals(layer, colorScheme) {
  if (layer === FHA.SCOUTING) {
    return scoutingIntervals;
  } if (colorScheme !== '1.0') {
    return vegetationV2ScaleColors;
  }
  return vegetationV1ScaleColors;
}

export function getPercentages(intervals, percentages = [], sublayer) {
  if (sublayer !== FHA.VEGETATION) {
    return intervals.map((interval, index) => ({
      ...interval,
      ...(percentages[index] !== undefined && {
        value: `${percentages[index]}%`,
      }),
    }));
  }
  return intervals;
}
